import { ChangeEvent, useEffect, useState } from "react";
import styles from "./AddSinglePlaceInput.module.css";
import Icon from "../../../common/Icon";
import { Field, getFormattedNumberStr } from "../../../common/Common";

interface AddSinglePlaceInputProps {
    requirement: boolean;
    item: Field;
    checkValidation: (item: Field) => boolean;
    onChange?: (value: string) => void;
    placeholder?: string;
    icon?: string;
    onClickIcon?: () => void;
}

export enum DataTemplate {
    none = "none",
    req = "req",
    imagesmode = "imagesmode",
    link = "link",
    call = "call",
    attach_money = "attach_money",
    format_quote = "format_quote",
}
/**
 * @author bakim
 * @date 2024-10-05
 * @description 단일 장소 추가 폼의 input 컴포넌트
 * @param props AddSinglePlaceInputProps
 * @returns <AddSinglePlaceInput>
 */
const AddSinglePlaceInput = (props: AddSinglePlaceInputProps) => {
    const [valid, setValid] = useState<boolean>();
    const [value, setValue] = useState<string>(props.item.value);
    const [template, setTemplate] = useState<DataTemplate>(DataTemplate.none);
    const [message, setMessage] = useState<string>("");

    useEffect(() => {
        !props.requirement && props.item.template && setTemplate(DataTemplate[props.item.template]);
        props.requirement && setTemplate(DataTemplate.req);
        // props.item.template === DataTemplate.attach_money && setValue(getFormattedNumberStr(props.item.value)); // 값 조작 전에 값이 변경되지 않도록 삭제 | smyun | 250908
        props.item.value && setValid(true);
    }, []);

    useEffect(() => {
        if (valid || valid === undefined) {
            setMessage("");
            return;
        }
        setErrorMEssage();
    }, [valid]);

    /**
     * @description 데이터 유형 별 경고 메시지 설정
     */
    const setErrorMEssage = () => {
        if (template === DataTemplate.call) {
            setMessage("* 9-12자의 숫자로 입력해주세요.");
        } else if (template !== DataTemplate.req) {
            setMessage("* 254자 이내로 작성해주세요.");
        }
    };

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const target = e.currentTarget;
        let value = target.value;

        switch (template) {
            case DataTemplate.call:
                value = value.replace(/[^0-9]+/g, "");
                break;
            case DataTemplate.attach_money:
                value = getFormattedNumberStr(value.replace(/[^0-9]+/g, ""));
                break;
        }

        const isValid = props.checkValidation({ ...props.item, value, template });

        setValue(value);
        setValid(isValid);
        props.onChange && props.onChange(value);
    };

    return (
        <div className={styles.item}>
            <div className={styles.header}>
                {props.requirement ? <Icon name="check" color={valid ? "default" : "lightGrey"} /> : <></>}
                {![DataTemplate.none, DataTemplate.req].includes(template) && <Icon name={template} size="small" color="grey" />}
                <label className={styles.label} htmlFor={props.item.fieldKey}>
                    {props.item.fieldName}
                </label>
                <span className={styles.caution}>{message}</span>
            </div>
            <input className={styles.input} name={props.item.fieldKey} onChange={onInputChange} placeholder={props.placeholder ?? ""} value={value} />
        </div>
    );
};

export default AddSinglePlaceInput;
